var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icon_-_Facebook",
    width: 24,
    height: 24,
    "data-name": "Icon - Facebook",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#fff;opacity:0}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__icon",
    d: "M0 0h24v24H0z",
    className: "prefix__cls-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_-_Facebook-2",
    "data-name": "Icon - Facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__frame",
    d: "M0 0h9v16H0z",
    className: "prefix__cls-1",
    transform: "translate(7 4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__icons8-facebook-f-filled",
    fill: "#4666ae",
    d: "M18.923 5.13h1.731A.347.347 0 0 0 21 4.783V2.439a.346.346 0 0 0-.32-.347C20.129 2.053 19.053 2 18.28 2a3.272 3.272 0 0 0-3.51 3.606v2.307h-2.424a.347.347 0 0 0-.346.348V10.7a.347.347 0 0 0 .346.348h2.423v6.609a.347.347 0 0 0 .346.348h2.423a.347.347 0 0 0 .346-.348v-6.614h2.5a.347.347 0 0 0 .344-.31L21 8.3a.347.347 0 0 0-.344-.386h-2.771v-1.74a1.041 1.041 0 0 1 1.038-1.044z",
    transform: "translate(-5 2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.98e9a18fb6461a32cca436ac8d05303a.svg";
export { ForwardRef as ReactComponent };